import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-teacherManage",
  "use": "icon-teacherManage-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-teacherManage\"><path d=\"M76.739129 836.721778V389.688889l426.496 221.525333 426.666667-221.354666 0.341333 446.634666-381.269333 167.424a113.777778 113.777778 0 0 1-91.477334 0l-380.757333-167.253333zM447.768462 13.368889A121.856 121.856 0 0 1 549.030684 8.931556l9.671112 4.437333 427.804444 218.624a36.579556 36.579556 0 0 1 4.551111 62.350222l-5.12 3.072-429.169778 209.806222a121.856 121.856 0 0 1-96.711111 4.437334l-10.353778-4.437334L20.589796 297.415111a36.579556 36.579556 0 0 1-5.688889-62.293333l5.12-3.128889L447.768462 13.368889z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/teacherManage.svg
// module id = c55c
// module chunks = 78